module.exports = __webpack_public_path__ + "static/media/hangman01.352e15ff.svg";